import { render, staticRenderFns } from "./TenantCorporateInfoManager.vue?vue&type=template&id=06215804&scoped=true&"
import script from "./TenantCorporateInfoManager.vue?vue&type=script&lang=js&"
export * from "./TenantCorporateInfoManager.vue?vue&type=script&lang=js&"
import style0 from "./TenantCorporateInfoManager.vue?vue&type=style&index=0&id=06215804&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06215804",
  null
  
)

export default component.exports